import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

function List() {
    const dispatch = useDispatch();

    const profileFilter = chooseProfileFilter();

    const navigate = useNavigate();

    const pathFrontEnd = '/bankinghistories/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllBankAccounts: config.endpoints.backend + 'bankaccounts/getall',
        endpointDelete: `${config.endpoints.backend}bankinghistories/delete`,
        endpoint: config.endpoints.backend + 'bankinghistories/getbycompetency'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 2
            } : {},
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'month',
                type: 'select',
                label: 'Mês',
                options: [{
                    value: '01',
                    label: 'Janeiro'
                },
                {
                    value: '02',
                    label: 'Fevereiro'
                },
                {
                    value: '03',
                    label: 'Março'
                },
                {
                    value: '04',
                    label: 'Abril'
                },
                {
                    value: '05',
                    label: 'Maio'
                },
                {
                    value: '06',
                    label: 'Junho'
                },
                {
                    value: '07',
                    label: 'Julho'
                },
                {
                    value: '08',
                    label: 'Agosto'
                },
                {
                    value: '09',
                    label: 'Setembro'
                },
                {
                    value: '10',
                    label: 'Outubro'
                },
                {
                    value: '11',
                    label: 'Novembro'
                },
                {
                    value: '12',
                    label: 'Dezembro'
                }],
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'year',
                type: 'year',
                selectable: true,
                label: 'Ano',
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Histórico de Transações',
        labelTitleButtonAdd: 'Importar Extrato',
        fieldsShowOnDelete: ['trnamt'],
        showPrintButtons: true,
        canEdit: false,
        canView: false,
        canDelete: false,
        viewActionColumn: false,
        formFilters: filters,
        filter: {
            ...profileFilter,
        },
        columns: [
            {
                name: 'entity_name',
                label: 'Entidade',
            },
            {
                name: 'project_name',
                label: 'Projeto',
            },
            {
                name: 'formatted_competency',
                label: 'Competência'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Visualizar',
                        icon: 'fas fa-eye',
                        onClick: async item => {
                            const banking_history_params = {
                                pdc_project_id: item.pdc_project_id,
                                pdc_entity_id: item.pdc_entity_id,
                                competency: item.competency
                            }

                            dispatch({ type: 'UPDATE_SESSION', key: 'banking_history_params', value: banking_history_params });
                            navigate(`/bankinghistories/list`)
                        },
                        width: '10%'
                    }
                ]
            }
        ],
        buttonsListContainer: [
            {
                name: 'files_entity_employees',
                class: 'btn btn-secondary',
                label: 'Importações',
                tooltipLabel: 'Verificar importações',
                callback: async () => {
                    navigate(`/bankinghistories/files`)
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                buttons={list.buttonsListContainer}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
